import type { MouseEventHandler, ReactNode } from 'react'
import React from 'react'
import classNames from 'classnames'
import Link from '@/components/Common/Link'
import BackArrow from '@/assets/PageHeader/Back.inline.svg'
import ArrowDown from '@/assets/common/arrowDown.inline.svg'

export interface PageHeaderProps {
  onClick?: MouseEventHandler<Element>
  children?: ReactNode
  link?: string
  nativeAnchor?: boolean
  childrenStyle?: string
  isAngularArrow?: boolean
}

function NavigationArrowPersuasion({
  children,
  onClick,
  link,
  nativeAnchor = false,
  childrenStyle = '',
  isAngularArrow = false,
}: PageHeaderProps) {
  return (
    <div className="flex w-full items-center">
      {onClick ? (
        <div>
          {isAngularArrow ? (
            <ArrowDown
              height="24"
              width="24"
              className="white text-brand-grey-light scale-120 rotate-90"
              onClick={onClick}
            />
          ) : (
            <BackArrow
              className="cursor-pointer"
              height="24"
              width="24"
              onClick={onClick}
            />
          )}
        </div>
      ) : (
        <Link
          href={link ?? '/us-stocks/screener'}
          className="block"
          nativeAnchor={nativeAnchor}
        >
          <BackArrow className="cursor-pointer" height="20" width="20" />
        </Link>
      )}
      <div
        className={classNames(
          'text-brand-black m-0 px-2 text-xl md:text-4xl',
          childrenStyle,
        )}
      >
        {children}
      </div>
    </div>
  )
}

export default NavigationArrowPersuasion
